import { NavLink } from "react-router-dom";
import { getValue } from "@utils/lodash";
import BulkUploadLocation from "../../Locations/BulkUploadLocation";
import BulkUpload from "../BulkUpload";
import Search from "../Search";
import { useNavigate } from "react-router-dom";
import { QueryRequestHelper } from "@_common/query-request-helper";
import InputField from "@_common/InputRuleFeild";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import ChangeOwner from "../ChangeOwner";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import BulkViewLogs from "@components/BulkUploadDropdown/bulk-logs";

const SearchHeader = (props: any) => {
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let compliance_task_ids: any = urlSearchParams.getAll(
    "compliance_task_ids[]"
  );
  const removeCalenderList = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let del: any = `compliance_task_ids[]`;
    delete params[del];
    if (getValue(props, `id`, "") === "id") {
      let queryRequest = QueryRequestHelper(params);
      let path = window.location.pathname.split("/list/id")[0];
      navigate(`${path}?${queryRequest}`);
    } else {
      let queryRequest = QueryRequestHelper(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  return (
    <section className="add-filter-wrapper add-filter-wrapper--border  d-flex align-items-center justify-content-between">
      <div className="add-filter-wrapper__add d-flex align-items-center ">
        {props.back && (
          <NavLink to={`${props.backUrl}`}>
            <img
              src="/images/back-link.svg"
              className="img-fluid ml-5"
              height={24}
              width={24}
            />
          </NavLink>
        )}
        {props.add != "false" &&
          (getValue(props, `isAdd`, false) ? (
            <div
              className="add-filter-wrapper__add-icon d-flex cursor-pointer"
              onClick={() => props.handleAddFun()}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
                <path
                  d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                  fill="#ffffff"
                />
              </svg>
            </div>
          ) : (
            <NavLink to={`${props.route}`} className="px-3">
              <div className="add-filter-wrapper__add-icon d-flex">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
                  <path
                    d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                    fill="#ffffff"
                  />
                </svg>
              </div>
            </NavLink>
          ))}
        {props.smartFilter && (
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={props.handleFilter}
          >
            <img
              src="/images/filter-icon.svg"
              className="img-fluid cursor-pointer mr-2"
              height={24}
              width={24}
            />
            <p style={{ color: "#276ef1" }}>Filter</p>&nbsp;&nbsp;&nbsp;
            {props.isHeadingVisibleByDefault && (
              <>
                {props.isFilterHeadingVisible && (
                  <>
                    <h6 className="add-filter-wrapper__filter-status">
                      {props.headingText || "Filter Status"}
                    </h6>
                  </>
                )}
                {props.isFilterSubHeadingVisible && (
                  <h6 className="add-filter-wrapper__add-filter-title">
                    All <span>ADD FILTER</span>
                  </h6>
                )}
              </>
            )}
            {/* {props.isFilterHeadingVisible && (
            <>
              <h6 className="add-filter-wrapper__filter-status">
                {props.headingText || 'Filter Status'}
              </h6>
            </>
          )}
          {props.isFilterSubHeadingVisible && (
            <h6 className="add-filter-wrapper__add-filter-title">
              All <span>ADD FILTER</span>
            </h6>
          )} */}
          </div>
        )}
        {props.filter && (
          <div className="d-flex justify-content-between gap">
            <div className="grid mb-1">
              <div className="input-grid-item">
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Choose Status"
                  className="form-control w-100"
                  name="country_id"
                  id="country_id"
                  options={props.filterList}
                  value={
                    getValue(props, `filterList.length`, 0) > 0 &&
                    getValue(props, `filterList`, []).filter(
                      (item: object) =>
                        getValue(item, `value`, "") ===
                        getValue(params, `is_configured`, "")
                    )
                  }
                  onChange={(e: any) =>
                    props.handleChangeStatus(
                      "is_configured",
                      getValue(e, `value`, "")
                    )
                  }
                  label="Country"
                  isClear
                />
              </div>
            </div>
          </div>
        )}
        &nbsp;&nbsp;&nbsp;
        {props.statusFilter && (
          <div className="d-flex justify-content-between gap">
            <div className="grid mb-1">
              <div className="input-grid-item">
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Choose Status"
                  className="form-control w-100"
                  name="country_id"
                  id="country_id"
                  options={props.filterList}
                  value={
                    getValue(props, `filterList.length`, 0) > 0 &&
                    getValue(props, `filterList`, []).filter(
                      (item: object) =>
                        getValue(item, `value`, "") ===
                        getValue(params, `status`, "")
                    )
                  }
                  onChange={(e: any) =>
                    props.handleChangeStatus("status", getValue(e, `value`, ""))
                  }
                  label="Country"
                  isClear
                />
              </div>
            </div>
          </div>
        )}
        &nbsp;&nbsp;&nbsp;
        {props.filterLocation && (
          <div className="d-flex justify-content-between gap">
            <div className="grid mt-2">
              <FilterSearchDropdown
                placeholder={"Search Location"}
                options={props.locationList}
                searchLoading={props.searchLoading}
                handleChange={(val: any) => props.handleTriggerLocation(val)}
                handleClick={(e: any) =>
                  props.handleChangeStatus("location_id", getValue(e, `id`, ""))
                }
                value={
                  getValue(props, `locationList.length`, 0) > 0 &&
                  getValue(props, `locationList`, []).filter(
                    (item: object) =>
                      getValue(item, `id`, "") ===
                      getValue(params, `location_id`, "")
                  )[0]
                }
                label="label"
                id="id"
                name="Location"
              />
            </div>
          </div>
        )}
        {props.filterFrequency && (
          <div className="grid">
            <div className="input-grid-item">
              <FilterSearchDropdown
                placeholder={"Search Frequency"}
                options={props.frequencyList}
                searchLoading={props.searchFrequencyLoading}
                handleChange={(val: any) => props.handleTriggerFrequency(val)}
                handleClick={(e: any) =>
                  props.handleChangeStatus(
                    "frequency_id",
                    getValue(e, `id`, "")
                  )
                }
                value={
                  getValue(props, `frequencyList.length`, 0) > 0 &&
                  getValue(props, `frequencyList`, []).filter(
                    (item: object) =>
                      getValue(item, `id`, "") ==
                      getValue(params, `frequency_id`, "")
                  )[0]
                }
                label="label"
                id="id"
                name="Frequency"
              />
            </div>
          </div>
        )}
        {props.filterConfigure && (
          <div className="grid">
            <div className="input-grid-item">
              <InputField
                inputType="INPUT_REACT_SELECT_MODAL"
                placeholder="Choose Configuration Type"
                className="form-control w-100"
                name="is_configured"
                id="is_configured"
                options={props.configureStatus}
                value={
                  getValue(props, `configureStatus.length`, 0) > 0 &&
                  getValue(props, `configureStatus`, []).filter(
                    (item: object) =>
                      getValue(item, `value`, "") ==
                      getValue(params, `is_configured`, "")
                  )
                }
                onChange={(e: any) =>
                  props.handleChangeStatus(
                    "is_configured",
                    getValue(e, `value`, "")
                  )
                }
                label="Country"
                isClear
              />
            </div>
          </div>
        )}
        &nbsp;&nbsp;&nbsp;
        {props.activeStatus && (
          <div className="grid">
            <div className="input-grid-item">
              <InputField
                inputType="INPUT_REACT_SELECT_MODAL"
                placeholder="Choose Activation Status"
                className="form-control w-100"
                name="activation_status"
                id="activation_status"
                options={props.activationStatus}
                value={
                  getValue(props, `activationStatus.length`, 0) > 0 &&
                  getValue(props, `activationStatus`, []).filter(
                    (item: object) =>
                      getValue(item, `value`, "") ==
                      getValue(params, `activation_status`, "")
                  )
                }
                onChange={(e: any) =>
                  props.handleChangeStatus(
                    "activation_status",
                    getValue(e, `value`, "")
                  )
                }
                label="Country"
                isClear
              />
            </div>
          </div>
        )}
        &nbsp;&nbsp;&nbsp;
        {props.filterCompliance && (
          <div className="select-grid">
            <div className="select-input-grid-item">
              <InputField
                inputType="INPUT_REACT_SELECT_MODAL"
                placeholder="Choose Compliance Type"
                className="form-control w-100"
                name="compliance_type_id"
                id="compliance_type_id"
                options={props.peComplianceList}
                value={
                  getValue(props, `peComplianceList.length`, 0) > 0 &&
                  getValue(props, `peComplianceList`, []).filter(
                    (item: object) =>
                      getValue(item, `id`, "") ==
                      getValue(params, `compliance_type_id`, "")
                  )
                }
                onChange={(e: any) =>
                  props.handleChangeStatus(
                    "compliance_type_id",
                    getValue(e, `id`, "")
                  )
                }
                label="Country"
                isClear
              />
            </div>
          </div>
        )}
        &nbsp;&nbsp;&nbsp;
        {props.filterComplianceStatus && (
          <div className="select-grid">
            <div className="select-input-grid-item">
              <InputField
                inputType="INPUT_REACT_SELECT_MODAL"
                placeholder="Choose Compliance Status"
                className="form-control w-100"
                name="compliance_status"
                id="compliance_status"
                options={props.complianceStatusOptions}
                value={getValue(props, `compliance_status_ID[${0}]`, "")}
                onChange={(e: any) =>
                  props.handleChangeStatus(
                    "compliance_status",
                    getValue(e, `value`, "")
                  )
                }
                label="Country"
                isClear
              />
            </div>
          </div>
        )}
        {getValue(compliance_task_ids, `length`, 0) > 0 && (
          <div
            className="d-flex align-center"
            style={{
              backgroundColor: "#EFF5FE",
              padding: "5px",
              borderRadius: "5px",
              color: "rgb(26, 115, 232)",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <h6 className="filter-form-wrappper__title">Calender List</h6>
            <img
              src="/images/close-red.svg"
              className="img-fluid cursor-pointer"
              height={20}
              width={20}
              onClick={removeCalenderList}
              style={{ marginLeft: "5px" }}
            />
          </div>
        )}
      </div>
      <div className="add-filter-wrapper__filter d-flex align-items-center">
        {props.search !== "false" && (
          <Search
            searchInput={getValue(props, `searchInput`, "")}
            showSearchTextbox={getValue(props, `showSearchTextbox`, "")}
            toggleSearch={props.toggleSearch}
            toggleSearchClose={props.toggleSearchClose}
            handleChangeSearch={props.handleChangeSearch}
            calender={props.calender}
            handleNavigateCalenderView={props.handleNavigateCalenderView}
            removeCalenderList={removeCalenderList}
            compliance_task_ids={compliance_task_ids}
            searchPlaceholder={props.searchPlaceholder}
          />
        )}
        {props.isBulkUploadVisible === true && !props.locationUpload && (
          <BulkUpload />
        )}
        {props.isBulkUploadVisible === true && props.locationUpload && (
          <BulkUploadLocation />
        )}
        {getValue(props, `changeOwner`, false) && (
          <ChangeOwner handleModal={props.handleModal} isOpen={props.isOpen} />
        )}
        {/* &nbsp;&nbsp;&nbsp; */}
        {getValue(props, `downloadSelfComplianceReport`, false) && (
          <div
            className=" d-block justify-content-center cursor-pointer icon-content-holder"
            onClick={props.handleDownloadSelfComplianceReport}
          >
            <img
              src="/images/download-gray.svg"
              style={{
                height: "24px",
                width: "24px",
                margin: "0px auto",
              }}
            />
            <p style={{ fontSize: "10x" }}>
              {getValue(props, `downloadLoading`, false)
                ? "Please wait..."
                : "DOWNLOAD"}
            </p>
          </div>
        )}
        {props.commonUpload && (
          <BulkUploadDropdown
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(props, `dropdownOptions`, [])}
          />
        )}

        {props.commonViewLogs && (
          <BulkViewLogs
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(props, `dropdownOptions`, [])}
          />
        )}
        {/* &nbsp;&nbsp;&nbsp; */}
        {getValue(props, `viewDownloadedSelfComplianceReports`, false) && (
          <div
            className=" d-block justify-content-center cursor-pointer icon-content-holder"
            onClick={props.handleNavigateLogs}
          >
            <img
              src="/images/taskback.svg"
              style={{
                height: "24px",
                width: "24px",
                margin: "0px auto",
              }}
            />
            <p style={{ fontSize: "10px" }}>VIEW LOGS</p>
          </div>
        )}
        {getValue(props, `stop_schedule`, false) &&
          (props.scheduleLoading ? (
            <button className="ascent-button ascent-button--header-buttons ascent-button--primary">
              Please Wait...
            </button>
          ) : (
            <button
              className="ascent-button ascent-button--header-buttons ascent-button--primary"
              onClick={props.handleStopSchedule}
            >
              Stop Schedule
            </button>
          ))}
      </div>
    </section>
  );
};

export default SearchHeader;
